<template>
  <div id="app" :class="[pageType === 'pc' ? 'pc-wrapper' : '']">
    <div class="app-wrapper center-content" v-if="pageType === 'pc'">
      <div class="nav shadow">
        <div class="nav-content center-content">
          <span class="title">八爪鱼内容服务平台·</span>
          <span class="tip">新建裂变活动</span>
        </div>
      </div>
      <main>
        <ul class="menu shadow">
          <li :class="['menu-item', activeMenu === 'step1' ? 'active' : '']">第一步：输入涨粉公众号</li>
          <li :class="['menu-item', activeMenu === 'step2' ? 'active' : '']">第二步：设置回流自动回复</li>
          <li :class="['menu-item', activeMenu === 'step3' ? 'active' : '']">第三步：选择裂变物料</li>
        </ul>
        <router-view class="main-content shadow" />
      </main>
    </div>
    <router-view  v-if="pageType === 'h5'"/>
  </div>
</template>

<script>
import { localStorage, utils } from '@/util/index'
import Events from '@/engine/Events'

const searchToQuery = () => {
  const searchQuery = {}
  if (window.location.search) {
    window.location.search.replace(/\\u0026/g, '&').replace(/%5Cu0026/g, '&').substr(1).split('&').forEach(function(item) {
      searchQuery[item.split('=')[0]] = item.split('=')[1]
    })
  }
  return searchQuery
}

const validateOpenId = (vm) => {
  const query = utils.formatQueryString(location.href)
  const { openId, appId, fakeOpenId } = utils.formatQuery(query)
  const localAppId = localStorage.get('appId')
  const currentAppId = appId || localAppId || process.env.VUE_APP_ID
  const localOpenId = localStorage.get(`${currentAppId}-openId`)

  if (appId && appId !== localAppId) {
    localStorage.set('appId', appId)
  }
  if (!currentAppId) {
    if (location.href.indexOf('/follow') === -1) {
      location.href = '/follow/'
    }
    return
  }

  if (!fakeOpenId && !openId && !localOpenId) {
    const query = {}
    const encodeUrl = encodeURIComponent(window.location.origin + window.location.pathname + '?query=' + btoa(JSON.stringify(searchToQuery())))
    const accountId = '5bcedc1f8516ec1b50124de6'
    const oauthUrl = 'https://oauth.quncrm.com/' + accountId + '/v2/wechat/oauth?appid=' + (currentAppId) + '&scope=base&redirect_url=' + encodeUrl

    location.href = oauthUrl
    return
  } else if (openId) {
    localStorage.set(`${currentAppId}-openId`, openId)
    const openIdReg = new RegExp(`openId=${openId}&?`)
    const href = location.href.replace(openIdReg, '')
    location.href = href
  }
  vm.globalData.appId = currentAppId
  vm.globalData.openId = fakeOpenId || openId || localOpenId
}

const validateToken = async (vm) => {
  const tokenKey = `${process.env.NODE_ENV}-token`
  const token = localStorage.get(tokenKey)
  if (token) {
    vm.globalData.token = token
  } else {
    // await Profiles.login()
  }
}

export default {
  data () {
    return {
      loading: true,
      activeMenu: 'step1',
      pageType: '',
    }
  },
  mounted() {
    validateOpenId(this)
    if (this.$route.path.indexOf('/h5/follow') > -1) {
      this.pageType = 'h5'
    }
  },
  beforeDestory() {
    Events.uploadLogs()
  },
  watch: {
    '$route': function () {
      this.activeMenu = this.$route.name
      this.pageType = (this.$route.path.indexOf('/h5/') === -1 && this.$route.path.indexOf('/dushu') === -1) ? 'pc' : 'h5'
    },
  }
}
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background-color: #fff;
}

* {
  box-sizing: border-box;
}

.pc-wrapper {
  background-color: #ddd;
}

#app,
.app-wrapper {
  height: 100vh;
  // overflow: hidden;

  &.center-content,
  .center-content {
    width: 1240px;
    margin: auto;
    padding: 0 20px;
  }

  .shadow {
    box-shadow: 10px 10px 10px rgba(0, 0, 0, .2);
  }

  .nav {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 100px;
    line-height: 100px;
    background-color: #fff;

    .title {
      display: inline-block;
      font-size: 40px;
      line-height: 100px;
      color: #101010;
      vertical-align: top;
    }

    .tip {
      display: inline-block;
      font-size: 32px;
      line-height: 100px;
      color: #e51c23;
      vertical-align: top;
    }

    .nav-content {
      padding-left: 100px;
      background-image: url('assets/logo.png');
      background-repeat: no-repeat;
      background-size: 80px;
      background-position: 10px center;
    }
  }

  main {
    display: flex;
    // margin-top: 100px;
    padding: 120px 0 20px;
    height: 100%;
  }

  .menu {
    width: 300px;
    height: fit-content;
    flex-grow: 0;
    flex-shrink: 0;
    margin: 0 20px 0 0;
    padding: 20px 0;
    background-color: #fff;
    list-style: none;

    .menu-item {
      font-size: 20px;
      line-height: 60px;
      border-left: 10px solid #fff;
      padding-left: 20px;

      &.active {
        border-color: #9eabb4;
      }
    }
  }

  .main-content {
    width: 0;
    height: 100%;
    flex-grow: 1;
    flex-shrink: 1;
    background-color: #fff;
    overflow-y: auto;
  }
}
</style>
